import * as React from "react";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { MyLegalContactsTable } from "../../components/legal-contact/MyLegalContactsTable";
import { AllLegalContactsTable } from "../../components/legal-contact/AllLegalContactsTable";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";
import { HomeBreadcrumbWrapper } from "../../components/breadcrumb/HomeBreadcrumbWrapper";

const AllLegalContactsTableRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    return <AllLegalContactsTable instanceId={instanceId!} />;
};

const MyLegalContactsTableRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    return <MyLegalContactsTable instanceId={instanceId!} />;
};

export const legalContactRoutes = [
    {
        path: "/legal-contact/:instanceId/home",
        content: <AllLegalContactsTableRoute />,
        breadcrumbs: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <HomeBreadcrumbWrapper items={[
                { text: "Instance Home", href: `#/instance/${instanceId}/home` },
                { text: "Legal Contacts Home", href: `#/legal-contact/${instanceId}/home` }
            ]}/>;
        },
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="InstanceHome" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="AdminPortal" entityId={instanceId!} />;
        }
    },
    {
        path: "/legal-contact/:instanceId/myInfo",
        content: <MyLegalContactsTableRoute />,
        breadcrumbs: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <HomeBreadcrumbWrapper items={[
                { text: "Instance Home", href: `#/instance/${instanceId}/home` },
                { text: "My Legal Contacts", href: `#/legal-contact/${instanceId}/myInfo` }
            ]}/>;
        },
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="InstanceHome" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="AdminPortal" entityId={instanceId!} />;
        }
    }
];
